// extracted by mini-css-extract-plugin
module.exports = {"carouselWrapper":"carousel-wrapper_carouselWrapper__RZdXk","showCarousel":"carousel-wrapper_showCarousel__8j00T"};